// useLockBodyScroll.js
// import { useEffect } from "react";

// export function useLockBodyScroll(locked) {
//   useEffect(() => {
//     if (!locked) return;

//     const body = document.body;
//     const prevOverflow = body.style.overflow;

//     body.style.overflow = "hidden";

//     return () => {
//       body.style.overflow = prevOverflow;
//     };
//   }, [locked]);
// }

/* useLockBodyScroll.js */
import { useLayoutEffect } from "react";

export function forceReleaseBodyScrollLock() {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  const body = document.body;
  const html = document.documentElement;
  const fixedTop = body.style.position === "fixed" ? body.style.top : "";
  const restoreY = fixedTop ? Math.abs(parseInt(fixedTop || "0", 10)) || 0 : 0;

  html.style.overflow = "";
  html.style.scrollBehavior = "";
  body.style.overflow = "";
  body.style.overflowY = "";
  body.style.position = "";
  body.style.top = "";
  body.style.left = "";
  body.style.right = "";
  body.style.width = "";
  body.style.paddingRight = "";

  if (restoreY > 0) window.scrollTo(0, restoreY);
}

export function scheduleBodyScrollUnlockCleanup() {
  if (typeof window === "undefined") return;

  window.requestAnimationFrame(() => {
    window.setTimeout(forceReleaseBodyScrollLock, 0);
  });
}

export function useLockBodyScroll(isLocked, options = {}) {
  const strategy = options?.strategy || "fixed";

  useLayoutEffect(() => {
    if (!isLocked) return;

    const body = document.body;
    const html = document.documentElement;
    const scrollY = window.scrollY || window.pageYOffset;

    const prev = {
      htmlOverflow: html.style.overflow,
      htmlScrollBehavior: html.style.scrollBehavior,
      bodyPosition: body.style.position,
      bodyTop: body.style.top,
      bodyLeft: body.style.left,
      bodyRight: body.style.right,
      bodyWidth: body.style.width,
      bodyOverflowY: body.style.overflowY,
      bodyPaddingRight: body.style.paddingRight,
    };

    const scrollbarWidth = window.innerWidth - html.clientWidth;
    if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;

    if (strategy === "overflow") {
      html.style.overflow = "hidden";
      body.style.overflowY = "hidden";

      return () => {
        html.style.overflow = prev.htmlOverflow;
        body.style.overflowY = prev.bodyOverflowY;
        body.style.paddingRight = prev.bodyPaddingRight;
      };
    }

    html.style.overflow = "hidden";
    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
    body.style.overflowY = "scroll";

    return () => {
      const restoreY = Math.abs(parseInt(body.style.top || "0", 10)) || scrollY;

      html.style.scrollBehavior = "auto";
      html.style.overflow = prev.htmlOverflow;

      body.style.position = prev.bodyPosition;
      body.style.top = prev.bodyTop;
      body.style.left = prev.bodyLeft;
      body.style.right = prev.bodyRight;
      body.style.width = prev.bodyWidth;
      body.style.overflowY = prev.bodyOverflowY;
      body.style.paddingRight = prev.bodyPaddingRight;

      window.scrollTo(0, restoreY);

      requestAnimationFrame(() => {
        html.style.scrollBehavior = prev.htmlScrollBehavior;
      });
    };
  }, [isLocked, strategy]);
}

// useLockBodyScroll.js
// import { useEffect, useRef } from "react";

// export function useLockBodyScroll(locked) {
//   const scrollYRef = useRef(0);

//   useEffect(() => {
//     const body = document.body;
//     const html = document.documentElement;

//     if (!locked) return;

//     const scrollY = window.scrollY || window.pageYOffset || 0;
//     scrollYRef.current = scrollY;

//     const prevBody = {
//       position: body.style.position,
//       top: body.style.top,
//       left: body.style.left,
//       right: body.style.right,
//       width: body.style.width,
//       overflow: body.style.overflow,
//       paddingRight: body.style.paddingRight,
//     };
//     const prevHtmlOverflow = html.style.overflow;

//     const scrollbarWidth = window.innerWidth - html.clientWidth;
//     if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;

//     html.style.overflow = "hidden";
//     body.style.overflow = "hidden";
//     body.style.position = "fixed";
//     body.style.top = `-${scrollY}px`;
//     body.style.left = "0";
//     body.style.right = "0";
//     body.style.width = "100%";

//     const preventTouchMove = (e) => e.preventDefault();
//     document.addEventListener("touchmove", preventTouchMove, { passive: false });

//     return () => {
//       document.removeEventListener("touchmove", preventTouchMove);

//       html.style.overflow = prevHtmlOverflow;
//       body.style.position = prevBody.position;
//       body.style.top = prevBody.top;
//       body.style.left = prevBody.left;
//       body.style.right = prevBody.right;
//       body.style.width = prevBody.width;
//       body.style.overflow = prevBody.overflow;
//       body.style.paddingRight = prevBody.paddingRight;

//       window.scrollTo(0, scrollYRef.current || 0);
//     };
//   }, [locked]);
// }
